import { Component, DestroyRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { EntityStatus, UserTwoFATokenVaultActions } from '@workspace/data-types';
import {
  AlertSnackBarService,
  ConfirmDialogAuraComponent,
  DialogData,
  UserTwoFAVerificationDialogAuraComponent,
} from '@workspace/ng-aura';
import { OpenIdService, UserStore } from '@workspace/ng-data-access';
import { ApiService } from '@workspace/ng-http';
import { catchError, EMPTY, filter, switchMap, tap } from 'rxjs';
import { DeleteAccountCoreComponent } from './delete-account/delete-account.component';

@Component({
  selector: 'core-user-confidentiality',
  templateUrl: './user-confidentiality.component.html',
  imports: [DeleteAccountCoreComponent, RouterModule],
  standalone: true,
})
export class UserConfidentialityCoreComponent {
  private destroyRef = inject(DestroyRef);
  private userStore = inject(UserStore);
  private api = inject(ApiService);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private alertSnackbar = inject(AlertSnackBarService);
  private openIdService = inject(OpenIdService);

  title = input<string>();
  isLoading = true;
  currentUser = this.userStore.currentUser;

  constructor() {
    this.currentUser();
    this.isLoading = false;
  }

  openDeleteAccountFlow(): void {
    this.dialog
      .open(UserTwoFAVerificationDialogAuraComponent, {
        data: { action: UserTwoFATokenVaultActions.DELETE_ACCOUNT },
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        filter((success) => !!success),
        switchMap(() =>
          this.dialog
            .open(ConfirmDialogAuraComponent, {
              data: {
                title: 'Confirmer la suppression',
                message:
                  'Êtes-vous sûr de vouloir supprimer définitivement votre compte ? Cette action est irréversible.',
                confirm: {
                  text: 'Supprimer',
                  class: 'primary destructive',
                },
              } as DialogData,
            })
            .afterClosed(),
        ),
        filter((confirmed) => !!confirmed),
        switchMap(() =>
          this.api
            .user()
            .account()
            .delete()
            .pipe(
              tap(() => {
                this.userStore.deleteUser();
                this.openIdService.wipeOut(false);
              }),
              catchError((error) => {
                console.error('Delete account failed:', error);
                this.alertSnackbar.error({
                  message: 'La suppression du compte a échoué. Veuillez réessayer.',
                });
                return EMPTY;
              }),
            ),
        ),
        tap(() => {
          void this.router.navigate(['/landing/goodbye'], {
            queryParams: { type: EntityStatus.DELETED },
          });
        }),

        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
